import axios from 'axios'
import { BUSCAR_REGRA_BILHETE } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default () => dispatch => axios.get(`${URL}/config-bilhete/regra`,SLOW_REQUEST_CONFIG)
  .then(response => dispatch({
    type: BUSCAR_REGRA_BILHETE,
    payload: response
  }));
